export const showcaseTemplate = `
<div class="criteo-showcase-container">
  <div class="criteo-showcase-content">
    <!-- Brand/Creative Zone (Left) -->
    <div class="criteo-showcase-brand">
      <a class="showcase-brand-content showcase-brand-cta" href="" target="_blank">
        <img class="showcase-brand-image" src="" alt="" loading="lazy" />
        <div class="showcase-brand-overlay">
          <div class="showcase-brand-text">
            <h3 class="showcase-brand-title"></h3>
            <p class="showcase-brand-description"></p>
          </div>
          <span class="showcase-cta-text">Comprar</span>
        </div>
      </a>
    </div>

    <!-- Products Zone (Right) -->
    <div class="criteo-showcase-products">
      <!-- Products will be injected here -->
    </div>

    <!-- Slider navigation arrows (visible only at intermediate breakpoint) -->
    <button class="showcase-slider-arrow showcase-slider-prev is-hidden" aria-label="Productos anteriores" type="button">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="15 18 9 12 15 6"></polyline>
      </svg>
    </button>
    <button class="showcase-slider-arrow showcase-slider-next" aria-label="Ver más productos" type="button">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="9 18 15 12 9 6"></polyline>
      </svg>
    </button>
  </div>
</div>
`;

export const showcaseProductCardTemplate = `
<div class="showcase-product-card">
  <a class="showcase-product-link" href="" title="">
    <div class="showcase-product-image-wrapper">
      <img class="showcase-product-image" src="" alt="" loading="lazy" />
    </div>
    <div class="showcase-product-info">
      <h4 class="showcase-product-title"></h4>
      <div class="showcase-product-rating">
        <!-- Rating will be inserted here -->
      </div>
      <div class="product-energy-tag">
        <!-- Energy tag will be inserted here -->
      </div>
    </div>

    <div class="showcase-product-price">
      <!-- Price will be inserted here -->
    </div>
  </a>
</div>
`;
